(() => {
  if (window.__ougistJpgCardDownloadPatchAsset) return;
  window.__ougistJpgCardDownloadPatchAsset = true;
  window.__ougistJpgCardDownloadPatch = true;

  const clean = (value) => String(value || '').replace(/\s+/g, ' ').trim();
  const cardText = (scope, name) => clean(scope.querySelector(`[data-ou-card="${name}"]`)?.textContent);
  const truncate = (value, maxChars) => {
    const text = clean(value);
    if (maxChars && text.length > maxChars) return `${text.slice(0, Math.max(0, maxChars - 3))}...`;
    return text;
  };
  const todayLabel = () => {
    try {
      return new Intl.DateTimeFormat('en', { month: 'short', day: '2-digit', year: 'numeric' }).format(new Date());
    } catch (error) {
      return new Date().toISOString().slice(0, 10);
    }
  };
  const roundedPath = (context, x, y, width, height, radius) => {
    const r = Math.min(radius, width / 2, height / 2);
    context.beginPath();
    context.moveTo(x + r, y);
    context.arcTo(x + width, y, x + width, y + height, r);
    context.arcTo(x + width, y + height, x, y + height, r);
    context.arcTo(x, y + height, x, y, r);
    context.arcTo(x, y, x + width, y, r);
    context.closePath();
  };
  const fillRound = (context, x, y, width, height, radius, fillStyle, alpha = 1) => {
    context.save();
    roundedPath(context, x, y, width, height, radius);
    context.fillStyle = fillStyle;
    context.globalAlpha = alpha;
    context.fill();
    context.restore();
  };
  const strokeRound = (context, x, y, width, height, radius, strokeStyle, alpha = 1) => {
    context.save();
    roundedPath(context, x, y, width, height, radius);
    context.strokeStyle = strokeStyle;
    context.globalAlpha = alpha;
    context.lineWidth = 2;
    context.stroke();
    context.restore();
  };
  const drawText = (context, text, x, y, font, color, maxWidth) => {
    context.save();
    context.font = font;
    context.fillStyle = color;
    context.textBaseline = 'alphabetic';
    context.fillText(text, x, y, maxWidth);
    context.restore();
  };
  const drawField = (context, label, value, x, y, maxChars, valueWidth = 300) => {
    drawText(context, label, x, y, '800 17px Arial, Helvetica, sans-serif', '#8fa4cd', 450);
    drawText(context, truncate(value, maxChars), x, y + 40, '800 26px Arial, Helvetica, sans-serif', '#ffffff', valueWidth);
  };
  const drawSmallCaps = (context, text, x, y, maxWidth) => {
    drawText(context, text, x, y, '800 16px Arial, Helvetica, sans-serif', '#b9c4dc', maxWidth || 420);
  };
  const drawChip = (context, x, y) => {
    fillRound(context, x, y, 118, 86, 18, '#f5cf83');
    strokeRound(context, x + 12, y + 12, 94, 62, 12, '#9f7434', 0.42);
    context.save();
    context.strokeStyle = 'rgba(118,75,25,.45)';
    context.lineWidth = 3;
    context.beginPath();
    context.moveTo(x + 59, y + 13);
    context.lineTo(x + 59, y + 73);
    context.moveTo(x + 13, y + 43);
    context.lineTo(x + 105, y + 43);
    context.moveTo(x + 34, y + 13);
    context.lineTo(x + 34, y + 73);
    context.moveTo(x + 84, y + 13);
    context.lineTo(x + 84, y + 73);
    context.stroke();
    context.restore();
  };
  const drawSeal = (context, x, y) => {
    fillRound(context, x, y, 122, 122, 61, '#ffffff', 0.96);
    strokeRound(context, x + 10, y + 10, 102, 102, 51, '#ff5a2c', 0.34);
    context.save();
    context.textAlign = 'center';
    drawText(context, 'OU', x + 61, y + 54, '900 32px Arial, Helvetica, sans-serif', '#ff5a2c', 82);
    drawText(context, 'ID', x + 61, y + 88, '900 30px Arial, Helvetica, sans-serif', '#17213d', 82);
    context.restore();
  };
  const drawBarcode = (context, x, y) => {
    context.save();
    context.globalAlpha = 0.78;
    context.fillStyle = '#ffffff';
    Array.from({ length: 48 }, (_, index) => {
      const barX = x + index * 6.2;
      const h = index % 7 === 0 ? 42 : index % 4 === 0 ? 34 : index % 3 === 0 ? 28 : 22;
      context.fillRect(barX, y + (42 - h), index % 5 === 0 ? 4.2 : 3, h);
    });
    context.restore();
  };
  const drawCodeLines = (context, value, x, y, width) => {
    const text = clean(value).toUpperCase();
    const parts = text.length > 18 ? [text.slice(0, 18), text.slice(18, 38)] : [text];
    parts.filter(Boolean).forEach((part, index) => {
      drawText(context, part, x, y + index * 30, '900 24px Arial, Helvetica, sans-serif', '#ffffff', width);
    });
  };
  const memberCenters = () => [...document.querySelectorAll('#member-center, .ou-member-center')];
  const activeMemberCenter = () => memberCenters().find((node) => !node.hidden && node.offsetParent !== null) || memberCenters()[0];
  const payloadFrom = (memberCenter) => {
    const memberId = cardText(memberCenter, 'memberId') || 'OUG-MEMBER';
    const serial = cardText(memberCenter, 'serial') || 'Registered product';
    const fileSeed = (serial || memberId || 'ougist-warranty-card').replace(/[^a-z0-9-]/ig, '-').replace(/-+/g, '-').replace(/^-|-$/g, '').toLowerCase();
    return {
      memberName: cardText(memberCenter, 'memberName') || 'OUGIST Member',
      memberId,
      serial,
      order: cardText(memberCenter, 'order') || 'OUGIST order',
      coverage: cardText(memberCenter, 'coverage') || 'Extended warranty active',
      activated: cardText(memberCenter, 'activated') || todayLabel(),
      email: cardText(memberCenter, 'email') || 'Email on file',
      fileName: `${fileSeed || 'ougist-warranty-card'}.jpg`,
    };
  };
  const createCanvas = (payload) => {
    const canvas = document.createElement('canvas');
    canvas.width = 1200;
    canvas.height = 740;
    const context = canvas.getContext('2d');
    const bg = context.createLinearGradient(0, 0, 1200, 740);
    bg.addColorStop(0, '#101a34');
    bg.addColorStop(0.45, '#233b78');
    bg.addColorStop(1, '#18264c');
    const surface = context.createLinearGradient(0, 0, 1200, 0);
    surface.addColorStop(0, 'rgba(255,255,255,.10)');
    surface.addColorStop(0.55, 'rgba(255,255,255,.03)');
    surface.addColorStop(1, 'rgba(255,255,255,.08)');

    context.fillStyle = '#ffffff';
    context.fillRect(0, 0, canvas.width, canvas.height);
    context.save();
    roundedPath(context, 0, 0, canvas.width, canvas.height, 56);
    context.clip();
    context.fillStyle = bg;
    context.fillRect(0, 0, canvas.width, canvas.height);
    context.fillStyle = surface;
    context.fillRect(0, 0, canvas.width, canvas.height);

    context.save();
    context.translate(1012, -72);
    context.rotate(Math.PI / 16);
    context.fillStyle = '#ff5a2c';
    context.globalAlpha = 0.92;
    context.fillRect(0, 0, 168, 900);
    context.fillStyle = '#ffffff';
    context.globalAlpha = 0.10;
    context.fillRect(28, 0, 18, 900);
    context.fillRect(104, 0, 9, 900);
    context.restore();

    context.globalAlpha = 0.13;
    context.fillStyle = '#ffffff';
    for (let x = 72; x < 1120; x += 36) {
      for (let y = 128; y < 650; y += 36) {
        context.fillRect(x, y, 2, 2);
      }
    }
    context.restore();

    strokeRound(context, 34, 34, 1132, 672, 42, '#ffffff', 0.24);
    fillRound(context, 58, 58, 1084, 624, 34, '#071229', 0.18);
    drawText(context, 'OUGIST', 82, 102, '900 48px Arial, Helvetica, sans-serif', '#ffffff', 320);
    drawSmallCaps(context, 'FIRE SAFETY CLUB', 84, 132, 240);
    fillRound(context, 890, 66, 222, 58, 29, '#e8f8ee');
    context.save();
    context.textAlign = 'center';
    drawText(context, 'ACTIVE WARRANTY', 1001, 102, '800 20px Arial, Helvetica, sans-serif', '#1c7d49', 178);
    context.restore();

    drawChip(context, 82, 180);
    drawText(context, 'EXTENDED WARRANTY', 230, 208, '900 30px Arial, Helvetica, sans-serif', '#ffdfd1', 480);
    drawText(context, 'DIGITAL MEMBER CARD', 230, 248, '900 40px Arial, Helvetica, sans-serif', '#ffffff', 500);
    drawText(context, truncate(payload.memberName, 32), 82, 354, '900 50px Arial, Helvetica, sans-serif', '#ffffff', 760);
    fillRound(context, 82, 384, 470, 56, 18, '#ffffff', 0.12);
    drawText(context, truncate(payload.memberId, 26), 110, 421, '800 26px Arial, Helvetica, sans-serif', '#ffdfd1', 410);

    fillRound(context, 760, 174, 300, 180, 28, '#ffffff', 0.11);
    strokeRound(context, 760, 174, 300, 180, 28, '#ffffff', 0.16);
    drawSmallCaps(context, 'VERIFIED PRODUCT RECORD', 792, 220, 230);
    drawCodeLines(context, payload.serial, 792, 256, 220);
    drawText(context, 'Support, warranty lookup, and replacement service.', 792, 312, '700 17px Arial, Helvetica, sans-serif', '#c5d0e8', 232);

    fillRound(context, 70, 470, 1060, 140, 26, '#ffffff', 0.10);
    strokeRound(context, 70, 470, 1060, 140, 26, '#ffffff', 0.15);
    drawField(context, 'ORDER REFERENCE', payload.order, 104, 526, 24, 240);
    drawField(context, 'COVERAGE', payload.coverage, 416, 526, 32, 320);
    drawField(context, 'ACTIVATED', payload.activated, 792, 526, 18, 220);

    drawText(context, 'EMAIL ON FILE', 82, 658, '800 17px Arial, Helvetica, sans-serif', '#8fa4cd', 260);
    drawText(context, truncate(payload.email, 46), 82, 694, '800 24px Arial, Helvetica, sans-serif', '#ffffff', 540);
    fillRound(context, 650, 648, 320, 50, 12, '#ffffff', 0.13);
    drawBarcode(context, 664, 654);
    drawSeal(context, 1010, 598);
    context.save();
    context.textAlign = 'center';
    drawText(context, 'CERTIFIED', 1008, 400, '900 22px Arial, Helvetica, sans-serif', '#ffffff', 170);
    drawText(context, 'OUGIST PRODUCT', 1008, 430, '800 16px Arial, Helvetica, sans-serif', '#c5d0e8', 170);
    context.restore();
    return canvas;
  };
  const toJpegBlob = (payload) => new Promise((resolve, reject) => {
    createCanvas(payload).toBlob((blob) => {
      if (blob) resolve(blob);
      else reject(new Error('Unable to create OUGIST warranty card JPG.'));
    }, 'image/jpeg', 0.94);
  });
  const downloadFrom = (memberCenter) => {
    const payload = payloadFrom(memberCenter);
    return toJpegBlob(payload).then((blob) => {
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = payload.fileName;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.setTimeout(() => URL.revokeObjectURL(url), 1000);
      return { fileName: payload.fileName, mimeType: blob.type, size: blob.size };
    });
  };

  window.ougistDownloadCard = () => {
    const memberCenter = activeMemberCenter();
    return memberCenter ? downloadFrom(memberCenter) : Promise.reject(new Error('OUGIST member card is not visible.'));
  };

  const safeJson = (value, fallback) => {
    try {
      return JSON.parse(value) || fallback;
    } catch (error) {
      return fallback;
    }
  };
  const readWarrantyDraft = () => safeJson(sessionStorage.getItem('ougistWarrantyRegistrationDraft'), {});
  const writeWarrantyDraft = (data) => sessionStorage.setItem('ougistWarrantyRegistrationDraft', JSON.stringify(data));
  const rootForm = () => document.getElementById('mpr-root');
  const registrationEndpoint = () => window.ougistWarrantyRegistrationEndpoint || '/apps/ougist-warranty/register';
  let publicRegistrationState = null;
  const publicRegistrationIsPaused = () => publicRegistrationState && publicRegistrationState.accepting === false;
  const ensurePublicRegistrationStatusPanel = () => {
    const root = rootForm();
    if (!root || !root.parentNode) return null;
    let panel = document.querySelector('[data-ou-public-registration-status]');
    if (panel) return panel;
    panel = document.createElement('div');
    panel.className = 'ou-public-registration-status';
    panel.setAttribute('data-ou-public-registration-status', 'true');
    panel.setAttribute('role', 'status');
    panel.setAttribute('tabindex', '-1');
    panel.style.cssText = [
      'box-sizing:border-box',
      'width:100%',
      'margin:0 0 18px',
      'padding:18px 20px',
      'border:1px solid rgba(255,90,44,.28)',
      'border-radius:8px',
      'background:#fff5ef',
      'color:#17213d',
      'font:600 15px/1.5 Arial,Helvetica,sans-serif',
      'box-shadow:0 14px 36px rgba(23,33,61,.08)',
    ].join(';');
    root.parentNode.insertBefore(panel, root);
    return panel;
  };
  const registrationActionButtons = () => {
    const root = rootForm();
    if (!root) return [];
    return [...root.querySelectorAll("button, input[type='submit'], [role='button']")].filter((button) => {
      if (button.closest?.('[data-ou-card-action], [data-ou-member-lookup]')) return false;
      const text = clean(button.value || button.innerText || button.textContent).toLowerCase();
      if (/(find|lookup|download|card)/.test(text)) return false;
      return button.matches?.("input[type='submit']")
        || /(register|activate|submit|complete|warranty|verify)/.test(text);
    });
  };
  const setPublicRegistrationControls = (paused) => {
    registrationActionButtons().forEach((button) => {
      if (paused) {
        if (!button.hasAttribute('data-ou-public-registration-original-disabled')) {
          button.setAttribute('data-ou-public-registration-original-disabled', button.disabled ? 'true' : 'false');
        }
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
        button.setAttribute('data-ou-public-registration-disabled', 'true');
        return;
      }
      if (button.getAttribute('data-ou-public-registration-disabled') !== 'true') return;
      button.disabled = button.getAttribute('data-ou-public-registration-original-disabled') === 'true';
      button.removeAttribute('aria-disabled');
      button.removeAttribute('data-ou-public-registration-disabled');
      button.removeAttribute('data-ou-public-registration-original-disabled');
    });
  };
  const renderPublicRegistrationState = (state) => {
    if (!state || state.accepting !== false) {
      setPublicRegistrationControls(false);
      const panel = document.querySelector('[data-ou-public-registration-status]');
      if (panel) panel.hidden = true;
      return;
    }
    const panel = ensurePublicRegistrationStatusPanel();
    if (!panel) return;
    panel.hidden = false;
    const message = clean(state.message)
      || 'Product registration is temporarily paused while we finish warranty system setup. Please check back later or contact support@ougist.com.';
    panel.innerHTML = [
      '<strong style="display:block;margin:0 0 6px;color:#ff5a2c;font-size:16px;">Product registration is temporarily paused</strong>',
      `<span>${message.replace(/[&<>"']/g, (char) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char]))}</span>`,
      '<span style="display:block;margin-top:8px;color:#5f6e8c;font-weight:500;">You can still find an existing warranty card below if you already registered.</span>',
    ].join('');
    setPublicRegistrationControls(true);
  };
  const probePublicRegistration = () => {
    if (!window.fetch) return;
    fetch(registrationEndpoint(), {
      method: 'GET',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    })
      .then((response) => response.ok ? response.json() : Promise.reject(new Error(`HTTP ${response.status}`)))
      .then((payload) => {
        if (!payload || !payload.publicRegistration) return;
        publicRegistrationState = payload.publicRegistration;
        renderPublicRegistrationState(publicRegistrationState);
      })
      .catch(() => {
        publicRegistrationState = { accepting: true, reason: 'probe_unavailable' };
        renderPublicRegistrationState(publicRegistrationState);
      });
  };
  const stopPausedPublicRegistration = (event) => {
    if (!publicRegistrationIsPaused()) return;
    const root = rootForm();
    if (!root) return;
    const target = event.target;
    const isRootSubmit = event.type === 'submit' && root.contains(target);
    const button = target?.closest?.("button, input[type='submit'], [role='button']");
    const isRegistrationButton = button && registrationActionButtons().some((candidate) => candidate === button || candidate.contains(button));
    if (!isRootSubmit && !isRegistrationButton) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    renderPublicRegistrationState(publicRegistrationState);
    document.querySelector('[data-ou-public-registration-status]')?.focus?.({ preventScroll: false });
  };
  const isCheckedValue = (value) => {
    const normalized = clean(value).toLowerCase();
    return value === true || normalized === 'true' || normalized === 'yes' || normalized === '1' || normalized === 'on';
  };
  const ensureMarketingOptIn = () => {
    const root = rootForm();
    if (!root) return null;
    const existing = document.querySelector('[data-ou-marketing-opt-in]');
    if (existing) return existing;
    const previous = readWarrantyDraft();
    const emailInput = root.querySelector("input[name='email'], input[type='email']");
    let insertTarget = root;
    if (emailInput && emailInput.parentNode) {
      const field = emailInput.closest?.('label, .form-field, .field, .input, div');
      insertTarget = !field || !field.parentNode || field === root ? emailInput : field;
    }
    if (!insertTarget || !insertTarget.parentNode) return null;
    const wrap = document.createElement('label');
    wrap.className = 'ou-marketing-opt-in';
    wrap.setAttribute('data-ou-marketing-opt-in-wrap', 'true');
    const checkbox = document.createElement('input');
    checkbox.type = 'checkbox';
    checkbox.value = 'true';
    checkbox.setAttribute('data-ou-marketing-opt-in', 'true');
    checkbox.checked = isCheckedValue(previous.marketingOptIn);
    const text = document.createElement('span');
    text.textContent = 'Send me product safety reminders, replacement notices, and OUGIST offers by email. I can unsubscribe anytime.';
    wrap.appendChild(checkbox);
    wrap.appendChild(text);
    insertTarget.parentNode.insertBefore(wrap, insertTarget.nextSibling);
    return checkbox;
  };
  const rootValue = (selector) => clean(rootForm()?.querySelector(selector)?.value);
  const selectedMultipleProductValue = () => {
    const checked = rootForm()?.querySelector("input[name='multiple-products']:checked");
    return checked ? clean(checked.value) : '';
  };
  const serialFromChip = () => {
    const chips = rootForm()?.querySelectorAll("li, [role='listitem']") || [];
    for (let index = 0; index < chips.length; index += 1) {
      const text = clean(chips[index].innerText || chips[index].textContent).replace(/\bdelete\b/ig, '');
      const matches = text.match(/[A-Z0-9][A-Z0-9-]{7,}/g);
      if (matches?.length) return matches[0];
    }
    return '';
  };
  const collectWarrantyDraft = () => {
    const previous = readWarrantyDraft();
    const marketingControl = ensureMarketingOptIn();
    const serialCandidate = serialFromChip() || rootValue("input[placeholder='Input the serial number']");
    const data = {
      order: rootValue("input[placeholder='Input the order number']") || previous.order || '',
      serial: previous.serial && serialCandidate && previous.serial.includes(serialCandidate) && previous.serial.length > serialCandidate.length
        ? previous.serial
        : serialCandidate || previous.serial || '',
      multipleProducts: selectedMultipleProductValue() || previous.multipleProducts || '',
      firstName: rootValue("input[name='firstName']") || previous.firstName || '',
      lastName: rootValue("input[name='last-name']") || previous.lastName || '',
      email: rootValue("input[name='email']") || previous.email || '',
      phone: rootValue("input[name='phone']") || previous.phone || '',
      city: rootValue("input[name='city']") || previous.city || '',
      state: rootValue("input[name='state']") || previous.state || '',
      country: rootValue("input[name='country']") || previous.country || 'US',
      marketingOptIn: marketingControl ? marketingControl.checked : isCheckedValue(previous.marketingOptIn),
    };
    writeWarrantyDraft(data);
    return data;
  };
  const registrationKey = (data) => [data.email, data.serial || data.order].filter(Boolean).join('|').toLowerCase();
  const cardId = (data) => {
    const seed = clean(data.serial || data.order || data.email || Date.now()).toUpperCase();
    const condensed = seed.replace(/[^A-Z0-9]/g, '').slice(-8) || 'MEMBER';
    return `OUG-${condensed}`;
  };
  const blobToDataUrl = (blob) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
  const backendQueueKey = 'ougistWarrantyBackendSyncQueue';
  const backendStatusKey = 'ougistWarrantyBackendSyncStatus';
  const readBackendQueue = () => safeJson(localStorage.getItem(backendQueueKey), []);
  const writeBackendQueue = (items) => localStorage.setItem(backendQueueKey, JSON.stringify(items.slice(0, 8)));
  const upsertBackendQueueItem = (item) => {
    const next = readBackendQueue().filter((existing) => existing.key !== item.key);
    next.unshift(item);
    writeBackendQueue(next);
  };
  const removeBackendQueueItem = (key) => writeBackendQueue(readBackendQueue().filter((item) => item.key !== key));
  const writeBackendStatus = (key, status, detail = '') => {
    const statuses = safeJson(localStorage.getItem(backendStatusKey), {});
    statuses[key] = {
      status,
      detail: clean(detail),
      updatedAt: new Date().toISOString(),
    };
    localStorage.setItem(backendStatusKey, JSON.stringify(statuses));
  };
  const sendWarrantyPayload = (item) => fetch(registrationEndpoint(), {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(item.payload),
  }).then((response) => {
    if (!response.ok) {
      return response.text().then((text) => {
        throw new Error(`HTTP ${response.status} ${text.slice(0, 120)}`);
      });
    }
    return response.json().catch(() => ({ ok: true }));
  });
  const flushWarrantyRegistrationQueue = () => {
    if (!window.fetch) return;
    const now = Date.now();
    readBackendQueue().forEach((item) => {
      if (item.nextAttemptAt && item.nextAttemptAt > now) return;
      const retryItem = {
        ...item,
        attempts: (item.attempts || 0) + 1,
      };
      retryItem.nextAttemptAt = now + Math.min(60 * 60 * 1000, Math.pow(2, retryItem.attempts) * 30 * 1000);
      upsertBackendQueueItem(retryItem);
      writeBackendStatus(retryItem.key, 'sending', 'Sending warranty registration backup');
      sendWarrantyPayload(retryItem)
        .then(() => {
          removeBackendQueueItem(retryItem.key);
          writeBackendStatus(retryItem.key, 'synced', 'Warranty profile and email backup accepted');
        })
        .catch((error) => {
          writeBackendStatus(retryItem.key, 'pending', error?.message || 'Waiting for warranty backend');
        });
    });
  };
  const pushWarrantyRegistration = (data) => {
    const key = registrationKey(data);
    if (!key || !data.email) return;
    const statuses = safeJson(localStorage.getItem(backendStatusKey), {});
    if (statuses[key]?.status === 'synced') return;
    const memberCenter = activeMemberCenter();
    if (!memberCenter) return;
    const payload = payloadFrom(memberCenter);
    toJpegBlob(payload)
      .then(blobToDataUrl)
      .then((imageDataUrl) => {
        upsertBackendQueueItem({
          key,
          attempts: 0,
          createdAt: new Date().toISOString(),
          payload: {
            customer: data,
            warranty: {
              memberId: cardText(memberCenter, 'memberId') || cardId(data),
              coverage: cardText(memberCenter, 'coverage') || 'Extended warranty active',
              activatedAt: new Date().toISOString(),
              sourceUrl: window.location.href,
            },
            card: {
              fileName: payload.fileName,
              imageDataUrl,
            },
          },
        });
        writeBackendStatus(key, 'queued', 'Warranty registration backup queued');
        flushWarrantyRegistrationQueue();
      })
      .catch((error) => {
        writeBackendStatus(key, 'error', error?.message || 'Unable to prepare warranty backup');
      });
  };
  const hasSuccessMessage = () => {
    const text = clean(rootForm()?.innerText || rootForm()?.textContent).toLowerCase();
    return text.includes('registration completed')
      || text.includes('registration is completed')
      || text.includes('registration finished')
      || text.includes('registered successfully')
      || text.includes('thank you')
      || text.includes('thanks');
  };
  const shouldSyncWarranty = () => {
    const memberCenter = activeMemberCenter();
    return hasSuccessMessage() || (memberCenter && memberCenter.hidden === false);
  };
  const checkWarrantyBridge = () => {
    if (!rootForm()) return;
    renderPublicRegistrationState(publicRegistrationState);
    const data = collectWarrantyDraft();
    if (shouldSyncWarranty()) pushWarrantyRegistration(data);
  };
  const startWarrantyBridge = () => {
    if (window.__ougistWarrantyRegistrationBridgePatch) return;
    window.__ougistWarrantyRegistrationBridgePatch = true;
    if (!rootForm()) {
      window.setTimeout(() => {
        window.__ougistWarrantyRegistrationBridgePatch = false;
        startWarrantyBridge();
      }, 500);
      return;
    }
    probePublicRegistration();
    checkWarrantyBridge();
    document.addEventListener('input', checkWarrantyBridge, true);
    document.addEventListener('change', checkWarrantyBridge, true);
    document.addEventListener('click', () => window.setTimeout(checkWarrantyBridge, 260), true);
    document.addEventListener('click', stopPausedPublicRegistration, true);
    document.addEventListener('submit', stopPausedPublicRegistration, true);
    window.addEventListener('online', flushWarrantyRegistrationQueue);
    window.setTimeout(flushWarrantyRegistrationQueue, 1200);
    new MutationObserver(checkWarrantyBridge).observe(document.body, { childList: true, subtree: true, characterData: true });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startWarrantyBridge, { once: true });
  } else {
    startWarrantyBridge();
  }

  document.addEventListener('click', (event) => {
    const action = event.target?.closest?.('[data-ou-card-action="download"]');
    if (!action) return;
    const memberCenter = action.closest('#member-center, .ou-member-center');
    if (!memberCenter) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    downloadFrom(memberCenter).catch(() => {
      action.setAttribute('aria-label', 'Download card unavailable');
    });
  }, true);
})();
